import type { Game } from '#imports'

export function trackGameOpen(origin: 'hero' | 'gametile', game: Game) {
    const { trackEvent } = useTracking()

    const gameSlug = game.slug

    trackEvent({ event_name: 'game-click', event_type: 'Click', meta_data: [{ origin, gameSlug }], log_entry: true }) // use refferer url in kibana to see where event originated (frontpage, spilleautomater and so on))
}
